module.exports = __webpack_public_path__ + "img/suax.7f3ca152.svg";